import { Injectable } from "@angular/core";
import type { Resolve } from '@angular/router';
import { UserSharedFacade } from '@medsurf/flat-facades';

@Injectable({
  providedIn: "root"
})
export class UsersAuthorResolver implements Resolve<void> {
  constructor(protected userSharedFacade: UserSharedFacade) {
  }

  resolve() {
    return this.userSharedFacade.requestGetUsers();
  }
}